var MultiSelect = {};

MultiSelect.Init = function () {

	$('.mt-multiselect.must-be-loaded').each( () => {
		$(this).removeClass('must-be-loaded')
		
	}).multiselect({
		buttonWidth: '100%',
		includeSelectAllOption: 'true',
		buttonClass: 'mt-multiselect btn btn-default form-control',
		nonSelectedText: BennerTranslations.noItemSelected,
		selectAllText: BennerTranslations.selectAll,
		nSelectedText: ' ' + BennerTranslations.itemsSelected,
		allSelectedText: BennerTranslations.allItemsSelected

	});
}
export default MultiSelect;